import React from 'react';
// import { FaRobot, FaChartLine, FaDatabase, FaCogs, FaBrain } from 'react-icons/fa';
import {AiOutlineGlobal } from "react-icons/ai";
import { FaMobileAlt, FaCloud, FaBrain, FaDatabase, FaTools, FaCogs, FaShieldAlt, FaLink, FaNetworkWired, FaPencilRuler, FaChartLine } from "react-icons/fa";
import '../../assets/styles/Domain.css';
import { MdOutlineStar } from "react-icons/md";   // Icon for list items
const { projectDomainData } = require('../../data/ProjectDomain.js');

const iconMap = {
  AiOutlineGlobal: AiOutlineGlobal,
  FaMobileAlt: FaMobileAlt,
  FaCloud: FaCloud,
  FaBrain: FaBrain,
  FaDatabase: FaDatabase,
  FaTools: FaTools,
  FaCogs: FaCogs,
  FaShieldAlt: FaShieldAlt,
  FaLink: FaLink,
  FaNetworkWired: FaNetworkWired,
  FaPencilRuler: FaPencilRuler,
  FaChartLine: FaChartLine,
};

function RightSide({ projectDomain, index }) {
  const Icon = iconMap[projectDomain.icon];
  return (
    <div key={index}
      className="relative p-6 rounded-2xl shadow-lg border border-cyan-800 project-card"
    >
      {/* Shine overlay */}
      <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-white/20 to-transparent opacity-40 pointer-events-none"></div>

      <div className="flex items-center gap-3 text-indigo-900 mb-2 text-2xl relative z-10">
        <span><Icon /></span>
        <span className="font-bold">{projectDomain.title}</span>
      </div>

      <p className="text-sm mb-3 text-stone-800 relative z-10">{projectDomain.description}</p>

      {/* Custom icon list */}
      <ul className="grid grid-cols-2 gap-2 text-sm text-stone-800 relative z-10 services-list">
        {projectDomain.services.map((service, i) => (
          <li key={i} className="flex items-center gap-2">
            <MdOutlineStar className="text-indigo-600" />
            <span>{service}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function RightDetails() {
  return (
    <div className="space-y-8 right-details right-details-container" id="rightDet">
      {projectDomainData.map((projectDomain, index) => (
        <RightSide projectDomain={projectDomain} index={index} />
      ))}
    </div>
  );
}
